"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBase64 = exports.fromBase64 = void 0;
var serde_1 = require("@smithy/core/serde");
Object.defineProperty(exports, "fromBase64", { enumerable: true, get: function () { return serde_1.fromBase64; } });
Object.defineProperty(exports, "toBase64", { enumerable: true, get: function () { return serde_1.toBase64; } });
